import { createContext } from 'react';
export var ThemesContext = createContext({});
//# sourceMappingURL=ThemesContext.js.map